import React from 'react';

import MainTemplate from 'pages/templates/MainTemplate';

const ImgExamination = () => {
  return (
    <MainTemplate>
      <h2>이미지 검수</h2>
    </MainTemplate>
  );
};

export default ImgExamination;
